import { render, staticRenderFns } from "./ShowWelcome.vue?vue&type=template&id=2b3ae46d&scoped=true&"
import script from "./ShowWelcome.vue?vue&type=script&lang=js&"
export * from "./ShowWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ae46d",
  null
  
)

export default component.exports